export interface Book {
  id: string;
  title: string;
  subtitle: string;
  author: string;
  description: string;
  inspiration?: string;
  inspirationText?: string;
  inspirationAuthor?: string;
  aboutText1?: string;
  aboutText2?: string;
  pages?: string;
  price?: number;
  coverImage: string;
  backImage?: string;
  available: boolean;
  soldOut?: boolean;
  purchaseUrl?: string;
  reviews?: Review[];
}

export interface Review {
  id: string;
  text: string;
  author: string;
  rating?: number;
}

export const books: Book[] = [
  {
    id: "omsorg",
    title: "OMSORG for dig med en livstruende sygdom",
    subtitle: "En bog om at møde livet med omsorg og nærvær",
    author: "Josef Kristensen",
    description: "En dybt personlig bog om at navigere gennem livets sværeste udfordringer med omsorg og nærvær.",
    inspiration: "Forfatterens inspiration",
    inspirationText: "Denne bog er skrevet ud fra et ønske om at hjælpe mennesker, der står overfor livstruende sygdomme, til at finde håb, mening og omsorg i deres situation.",
    inspirationAuthor: "Josef Kristensen",
    aboutText1: "En bog der taler direkte til dig, som har fået en livstruende diagnose, eller til dig som pårørende.",
    aboutText2: "Bogen giver konkrete værktøjer til at navigere gennem de følelser og tanker, der opstår i mødet med alvorlig sygdom.",
    pages: "Indbundet, 120 sider",
    price: 149.95,
    coverImage: "/images/bog-forside.png",
    backImage: "/images/bog-bagside.png",
    available: true,
    purchaseUrl: "https://buy.stripe.com/7sIaIhgR95xXgLeeUU",
    reviews: []
  },
  {
    id: "bookofcomfort",
    title: "Book of Comfort",
    subtitle: "En bog om menneskets værdi",
    author: "Josef Kristensen",
    description: "Bogen er skrevet til migrantarbejdere i lande, hvor der hverken er social sikkerhedsnet, økonomisk hjælp og omsorg, som vi kender det i Danmark. Bogen omhandler 10 forskellige situationer, hvor læserne kan spejle sig i ægte historier fra forfatterens arbejde i Mellemøsten. Omsorgen og opmuntringer i bogen har til hensigt at være til hjælp til mennesker som oplever sig ensom i livets svære fysiske og psykiske realiteter.\n\nBogen kan frit downloades, lyttes og læses her på siden.",
    pages: "Softcover, 88 sider",
    price: 70.00,
    coverImage: "/images/BookOfComfort.png",
    available: true,
    purchaseUrl: "https://buy.stripe.com/PLACEHOLDER",
    reviews: []
  },
  {
    id: "naervaer",
    title: "Nærvær når døden banker på",
    subtitle: "At møde døden med åbenhed og kærlighed",
    author: "Josef Kristensen",
    description: "En guidebog til at møde døden - både sin egen og andres - med nærvær, kærlighed og accept.",
    inspiration: "Om nærvær i livets sidste fase",
    inspirationText: "Døden er en del af livet, men hvordan møder vi den? Denne bog handler om at være til stede i livets sidste fase - både for os selv og for dem vi elsker.",
    inspirationAuthor: "Josef Kristensen",
    aboutText1: "En bog der hjælper med at navigere gennem dødens mysterium med værdighed og nærvær.",
    aboutText2: "Bogen giver praktiske råd og dybe refleksioner om hvordan vi kan møde døden som en naturlig del af livet.",
    pages: "Indbundet, 56 sider",
    price: 149.95,
    coverImage: "/images/naervaer-forside.jpg",
    backImage: "/images/naervaer-bagside.jpg",
    available: true,
    soldOut: true,
    reviews: []
  },
  {
    id: "toerst",
    title: "Tørst",
    subtitle: "En rejse med længsel og håb",
    author: "Josef Kristensen",
    description: "Et lille hæfte der omhandler åndelig tørst. Den kendte forfatter og filosof C. S. Lewis skrev engang: \"Hvis vi finder os selv med et ønske, som intet i denne verden kan tilfredsstille, er den mest sandsynlige forklaring, at vi er skabt til en anden verden.\" Hæftet er en reflektion over forfatterens egen tørst efter åndelige realiteter.",
    inspiration: "Om hæftet tørst",
    inspirationText: "Er der i den materialistiske verden mulighed for at komme ind i en dimension, hvor Guds nærvær opleves? Kan mennesker få en åndelig tørst tilfredsstillet, modtage styrke, visdom og hjælp fra en anden virkelighed. Forfatteren giver nogle råd til hvordan forhindringer kan fjernes og peger på den betingelsesløse kærlighed fra Gud som nøglen til nærværet.",
    inspirationAuthor: "Josef Kristensen",
    aboutText1: "Et lille hæfte der omhandler åndelig tørst. Den kendte forfatter og filosof C. S. Lewis skrev engang: \"Hvis vi finder os selv med et ønske, som intet i denne verden kan tilfredsstille, er den mest sandsynlige forklaring, at vi er skabt til en anden verden.\"",
    aboutText2: "Hæftet er en reflektion over forfatterens egen tørst efter åndelige realiteter. Er der i den materialistiske verden mulighed for at komme ind i en dimension, hvor Guds nærvær opleves? Kan mennesker få en åndelig tørst tilfredsstillet, modtage styrke, visdom og hjælp fra en anden virkelighed.",
    pages: "Hæfte, 26 sider",
    price: 49.00,
    coverImage: "/images/toerst-forside.jpg",
    backImage: "/images/toerst-bagside.jpg",
    available: true,
    reviews: []
  }
];

export const getBookById = (id: string): Book | undefined => {
  return books.find(book => book.id === id);
};

export const getAvailableBooks = (): Book[] => {
  return books.filter(book => book.available);
};
